var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundsettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#D4DDE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 14.375C18.125 15.4105 18.9645 16.25 20 16.25C21.0355 16.25 21.875 15.4105 21.875 14.375C21.875 13.3395 21.0355 12.5 20 12.5C18.9645 12.5 18.125 13.3395 18.125 14.375Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 20C18.125 21.0355 18.9645 21.875 20 21.875C21.0355 21.875 21.875 21.0355 21.875 20C21.875 18.9645 21.0355 18.125 20 18.125C18.9645 18.125 18.125 18.9645 18.125 20Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 25.625C18.125 26.6605 18.9645 27.5 20 27.5C21.0355 27.5 21.875 26.6605 21.875 25.625C21.875 24.5895 21.0355 23.75 20 23.75C18.9645 23.75 18.125 24.5895 18.125 25.625Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundsettings);
export default __webpack_public_path__ + "static/media/roundsettings.f8cc06e32631d6e5e70d91a24421fd5b.svg";
export { ForwardRef as ReactComponent };